export enum ColorpickerActionTypes {
  SET_COLORPICKER_BODY = 'SET_COLORPICKER_BODY',
  SET_COLORPICKER_EDGE = 'SET_COLORPICKER_EDGE',
  SET_COLORPICKER_EDGE_GLOSINESS = 'SET_COLORPICKER_EDGE_GLOSINESS',
  SET_COLORPICKER_EDGE_METALNESS = 'SET_COLORPICKER_EDGE_METALNESS',
  SET_COLORPICKER_THREAD = 'SET_COLORPICKER_THREAD',
  SET_COLORPICKER_INSIDE = 'SET_COLORPICKER_INSIDE',
  SET_COLORPICKER_TACK = 'SET_COLORPICKER_TACK',
}
